module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsMother.9fbaf06.jpg";